import { Subject } from "rxjs";
import {
  CRMChannel,
  CRMUnreadCounts,
} from "@jugl-web/rest-api/integrations/types";

export const crmUnreadIndicators$ = new Subject<
  | { type: "increment"; channel: CRMChannel }
  | { type: "decrement"; channel: CRMChannel }
  | { type: "set"; counts: CRMUnreadCounts }
>();
